export const EmailRegExp = /^[\w%+.-]+@[\d.A-Za-z-]+\.[A-Za-z]{2,}$/;
export const DomainRegExp = /^(?!:\/\/)([\dA-Za-z-]+\.)+[A-Za-z]{2,}$/;
